import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-partially-package-reasons',
  imports: [RouterOutlet],
  templateUrl: './partially-package-reasons.html',
  styleUrl: './partially-package-reasons.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PartiallyPackageReasons {}
